import {isBrowserContext} from 'core/helpers';

export const isTabletByScreen = () => {
    if (!isBrowserContext()) {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return 1024 > window.innerWidth && 768 <= window.innerWidth;
};

export const isMobileByScreen = () => {
    if (!isBrowserContext()) {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return 768 > window.innerWidth;
};

export const scrolltoHashWithOffset = (elementId: string, offset: number) => {
    const element = document.getElementById(elementId);

    const elementPosition = element?.getBoundingClientRect().top || 0;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });
};
